import HStack from '@jimmyboys/liita-ui/dist/components/HStack'
import OptionGroup from '@jimmyboys/liita-ui/dist/components/OptionGroup'
import VStack from '@jimmyboys/liita-ui/dist/components/VStack'
import React from 'react'
import { useController } from 'react-hook-form'
import toBool from 'utils/toBool'

const HFOptionGroup = (props) => {
	const { name, type, customLabel, shouldUnregister, ...attributes } = props
	const {
		field: { ref, ...field },
	} = useController({ name, shouldUnregister })

	const value =
		type === 'boolean' && typeof field.value === 'string'
			? toBool(field.value)
			: field.value

	return (
		<>
			{customLabel ? (
				<VStack>
					<HStack>
						<small>
							<strong>{customLabel?.label}: </strong>
							{customLabel?.value}
						</small>
					</HStack>
					<OptionGroup
						{...attributes}
						{...field}
						value={value}
						onChange={(e) => {
							const inputValue =
								type === 'boolean'
									? toBool(e.target.value)
									: e.target.value
							field.onChange(inputValue)
						}}
					/>
				</VStack>
			) : (
				<OptionGroup
					{...attributes}
					{...field}
					value={value}
					onChange={(e) => {
						const inputValue =
							type === 'boolean'
								? toBool(e.target.value)
								: e.target.value
						field.onChange(inputValue)
					}}
				/>
			)}
		</>
	)
}

export default HFOptionGroup
